var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsObject, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
export class PreventionChapterQuizQuestionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    index;
    rightAnswerIndex;
    question;
    preventionCourseModuleSectionId;
    preventionCourseModuleSection;
    answers;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "index", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Number)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "rightAnswerIndex", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "question", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", Object)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "preventionCourseModuleSectionId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "preventionCourseModuleSection", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionChapterQuizQuestionFullSizeDto.prototype, "answers", void 0);
//# sourceMappingURL=prevention-chapter-quiz-question.full-size.dto.js.map